import { jsx as _jsx } from "react/jsx-runtime";
export const defaultLoadingFallback = _jsx("h2", { children: "Loading..." });
export const defaultErrorFallback = _jsx("h2", { className: "c-red-500", children: "Error" });
//# sourceMappingURL=fallbacks.js.map